import { render, staticRenderFns } from "./TotalOrders.vue?vue&type=template&id=7a5d4f3a&"
import script from "./TotalOrders.vue?vue&type=script&lang=js&"
export * from "./TotalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports